import slugify from '@sindresorhus/slugify';
import classnames from 'classnames';

import Button from '@/components/Button';
import MarkdownRenderer from '@/components/MarkdownRenderer';
import Testimonial from '@/components/Testimonial';

export default function TestimonialCard(
  { excerpt, content, slug, ...props },
  index,
) {
  const linkPath = `/case-studies/${slugify(slug, { lower: true })}`;
  const isEven = index % 2;

  const wrapperClass = classnames(
    '-mx-6 flex items-center flex-col lg:flex-row py-6 md:py-12',
    {
      'lg:flex-row-reverse': isEven,
    },
  );

  return (
    <article key={index} className={wrapperClass}>
      <div className="mb-12 lg:mb-0 w-full max-w-2xl lg:w-1/2 px-6">
        <Testimonial
          {...props}
          content={content}
          slug={slug}
          linkPath={linkPath}
        />
      </div>

      <div className="w-full max-w-2xl lg:w-1/2 px-6">
        <div className="-mt-6">
          <MarkdownRenderer content={excerpt} />
        </div>

        {content !== null && (
          <Button href={linkPath} appearance="outline" colour="pink">
            Read Case Study &#8594;
          </Button>
        )}
      </div>
    </article>
  );
}
